export const uniqueId = () => {
  return `_${new Date().getUTCMilliseconds().toString() + new Date().getTime().toString()}`;
};
